import React from 'react';
import Button from '../Button/button';
import { ButtonTypes } from '../../Interfaces/componentTypes';
import { NoDataImg } from '../../Assets/Images';
import styles from './noData.module.scss';

interface IProps {
  message?: string,
  withButton?: boolean,
  imageStyle?: string,
  buttonTitle?: string,
  containerStyle?: string,
  textStyle?: string,
  buttonStyle?: string,
  buttonTitleStyle?: string,
  onPressButton?: () => void,
}

const NoData: React.FC<IProps> = (props) => {
  const { buttonTitle, message, withButton, imageStyle, buttonStyle, buttonTitleStyle, containerStyle, textStyle, onPressButton, } = props;
  return (
    <div className={`${styles.container} ${containerStyle!}`}>
      <img src={NoDataImg} alt='nodata.png' className={`${styles.image} ${imageStyle}`} />
      {message && <p className={`${styles.message} ${textStyle}`}>
        {message}
      </p>}
      {withButton
        &&
        <Button
          buttonType={ButtonTypes.Primery}
          title={buttonTitle!}
          onClick={onPressButton!}
          buttonStyle={buttonStyle}
          buttonTitleStyle={buttonTitleStyle}
        />
      }
    </div>
  )
};

export default NoData
